// Empty = same origin (works on main + any mirror without rebuild).
// Local CRA on :4000 still sets REACT_APP_API_URL=http://localhost in .env.
export const REACT_APP_API_URL = process.env.REACT_APP_API_URL ?? "";

export const REGIONS = [
  { name: "Россия", code: "ru" },
  { name: "Казахстан", code: "kz" },
  { name: "Азербайджан", code: "az" },
];

export const DEFAULT_REGION = "Россия";
